import { ToastContainer } from "react-toastify";
import { createPortal } from "react-dom";
import "react-toastify/dist/ReactToastify.css";
import { useAppContext } from "../../app_context";

export const ToastNotification = () => {
	const { siteColorTheme } = useAppContext();

	return createPortal(
		<ToastContainer
			className="toast-notification"
			theme={siteColorTheme === "DARK" ? "dark" : "light"}
		/>,
		document.body,
	);
};
